export default __webpack_public_path__ + "images/56fbc34199c50f7ff13b51bfbd81c9a9-easter_small.webp";